import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePlatformAuth } from '../auth/PlatformAuthContext';

export default function PlatformGuard({ children }) {
  const { isLoggedIn } = usePlatformAuth();
  const location = useLocation();
  if (!isLoggedIn) {
    return <Navigate to="/platform/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
